<template>
  <div
    v-if="marketingData.fullCoupons.length || marketingData.discounts.length"
    :class="_.block"
  >
    <div v-if="marketingData.fullCoupons.length" :class="_.coupon">
      <div :class="_.label">优惠券</div>
      <div :class="_.value">
        <div
          v-for="(item, index) in marketingData.fullCoupons"
          :key="index"
          :class="_.item"
        >
          {{ formatCoupon(item, true) }}
        </div>
      </div>
    </div>
    <div v-if="marketingData.discounts.length" :class="_.discount">
      <div :class="_.label">折扣优惠</div>
      <div :class="_.value">
        <div
          v-for="item in marketingData.discounts"
          :key="item.activityId"
          :class="_.item"
        >
          {{ item.describe }}
        </div>
      </div>
    </div>
    <div
      v-track="{
        name: '店铺优惠券-领券',
        id: `${componentId}-receive`,
      }"
      :class="_.button"
      @click="showReceive = true"
    >
      领券<img :src="require('./images/领券.png')" :class="_.icon" />
    </div>

    <van-action-sheet
      v-model="showReceive"
      :safe-area-inset-bottom="true"
      get-container="body"
      title="优惠"
      :class="_.sheet"
    >
      <div :class="_.detail">
        <div :class="_.discounts">
          <div
            v-if="marketingData.discounts && marketingData.discounts.length"
            :class="_.item"
          >
            <div :class="_.label">折扣优惠</div>
            <div :class="_.value">
              <div
                v-for="item in marketingData.discounts"
                :key="item.activityId"
              >
                {{ item.describe }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="marketingData.fullCoupons && marketingData.fullCoupons.length"
          :class="_.coupons"
        >
          <div :class="_.title">优惠券</div>
          <div :class="_.list">
            <div
              v-for="item in marketingData.fullCoupons"
              :key="item.activityId"
              :class="_.item"
            >
              <div :class="_.left">
                <div :class="_.price">
                  <div :class="_.unit">¥</div>
                  <div :class="_.value">{{ item.discountAmt }}</div>
                </div>
                <div :class="_.desc">{{ formatCoupon(item, true) }}</div>
              </div>

              <div :class="_.right">
                <div :class="_.main">
                  <div :class="_.title">{{ item.activityName }}</div>
                  <div :class="_.time">
                    <div>有效期：</div>
                    <div>{{ item.startTime }} ~ {{ item.endTime }}</div>
                  </div>
                </div>
                <div
                  v-track="{
                    name: '店铺优惠券-领取',
                    id: `${componentId}-receive-confirm`,
                  }"
                  :class="[_.button, item.receiveStatus === 2 && _.disabled]"
                  @click="handleReceiveClick(item)"
                >
                  {{
                    item.receiveStatus === 2
                      ? '已领取'
                      : item.receiveStatus === 1
                      ? '继续领取'
                      : '领取'
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Toast } from 'vant'

  export default Vue.extend({
    data() {
      return {
        curData: this.data,
        showReceive: false,
      }
    },

    computed: {
      marketingData() {
        return {
          fullCoupons:
            this.curData.find(item => item.resType === '101')?.extendData || [],
          discounts:
            this.curData.find(item => item.resType === '102')?.extendData || [],
        }
      },
    },

    methods: {
      async refreshCouponData() {
        this.curData = (
          await this.$dmbcApi.getComponentData({
            id: this.componentId,
            pageIndex: 1,
            pageSize: 100,
            useCdn: this.pageTheme.cdn,
          })
        ).list
      },

      formatCoupon(coupon, 可用样式 = false) {
        return coupon.minPoint === 0
          ? `无门槛${可用样式 ? '' : `减${coupon.discountAmt}元`}`
          : `满${coupon.minPoint}元${
              可用样式 ? '可用' : `减${coupon.discountAmt}元`
            }`
      },

      async handleReceiveClick(item) {
        const loading = Toast.loading('领取中...')
        try {
          await this.$dmbcApi.receiveCoupon({
            couponActId: item.activityId,
          })
          await this.refreshCouponData()
          Toast.success('领取成功')
        } finally {
          loading.close()
        }
      },
    },
  })
</script>

<style lang="scss" module="_">
  .block {
    position: relative;
    background: #ffffff;
    border-radius: 8px;
    font-size: 0;
    padding: 12px;

    .coupon {
      display: flex;
      align-items: flex-start;
      padding-right: 60px;

      .label {
        flex-shrink: 0;
        width: 48px;
        height: 21px;
        background: linear-gradient(135deg, #ffa05e 0%, #f66a27 100%);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #ffffff;
      }

      .value {
        flex-grow: 1;
        margin-left: 8px;
        margin-top: -8px;
        display: flex;
        flex-wrap: wrap;

        .item {
          margin-top: 8px;
          margin-right: 8px;
          padding: 0 6px;
          height: 23px;
          line-height: 23px;
          background: linear-gradient(
            121deg,
            #ffedeb 0%,
            #ffdddd 58%,
            #ffdeea 100%
          );
          border-radius: 4px;
          font-size: 12px;
          color: #ff2410;
        }
      }
    }

    .discount {
      display: flex;
      align-items: flex-start;
      padding-right: 60px;

      &:not(:first-child) {
        margin-top: 12px;
      }

      .label {
        flex-shrink: 0;
        width: 60px;
        height: 21px;
        background: linear-gradient(135deg, #fe6254 0%, #f62c27 100%);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #ffffff;
      }

      .value {
        flex-grow: 1;
        margin-left: 8px;

        .item {
          font-size: 13px;
          color: #333333;
          line-height: 18px;

          + .item {
            margin-top: 8px;
          }
        }
      }
    }

    .button {
      position: absolute;
      right: 0;
      top: 12px;
      flex-shrink: 0;
      width: 57px;
      height: 23px;
      background: #fe3826;
      border-radius: 12px 0px 0px 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #ffffff;

      .icon {
        margin-left: 4px;
        width: 10px;
        height: 11px;
      }

      &:active {
        filter: contrast(0.9);
      }
    }
  }

  .sheet {
    .detail {
      padding: 0 12px 12px 12px;
      min-height: 240px;
      box-sizing: border-box;

      .discounts {
        .item {
          display: flex;
          align-items: baseline;

          .label {
            flex-shrink: 0;
            background: #fff2f1;
            border-radius: 2px;
            font-size: 12px;
            color: #ff111c;
            line-height: 17px;
            padding: 0 4px;
          }

          .value {
            flex-grow: 1;
            margin-left: 12px;
            font-size: 14px;
            color: #222222;
            line-height: 20px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            &.vertical {
              align-items: flex-start;
              flex-direction: column;
            }

            &.singleLine {
              display: block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }

          &:not(:first-child) {
            margin-top: 14px;
          }
        }
      }

      .coupons {
        &:not(:first-child) {
          margin-top: 12px;
        }

        .title {
          font-size: 14px;
          font-weight: var(--bold-value);
          color: #222222;
          line-height: 22px;
        }

        .list {
          margin-top: 12px;

          .item {
            display: flex;
            align-items: center;
            background-image: url('./images/优惠券背景.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            width: 100%;
            height: 92px;

            .left {
              flex-shrink: 0;
              width: 105px;
              text-align: center;

              .price {
                display: inline-flex;
                align-items: baseline;

                .unit {
                  font-size: 12px;
                  font-weight: bold;
                  color: #ff111c;
                  line-height: 17px;
                }

                .value {
                  font-size: 40px;
                  font-weight: 600;
                  color: #ff111c;
                  line-height: 40px;
                }
              }

              .desc {
                font-size: 12px;
                color: #ff111c;
                line-height: 17px;
              }
            }

            .right {
              flex-grow: 1;
              display: flex;
              align-items: center;
              padding: 0 12px;

              .main {
                flex-grow: 1;

                .title {
                  font-size: 14px;
                  font-weight: bold;
                  color: #333333;
                  line-height: 20px;
                }

                .time {
                  margin-top: 10px;
                  font-size: 12px;
                  color: #333333;
                  line-height: 17px;
                }
              }

              .button {
                flex-shrink: 0;
                width: 66px;
                height: 26px;
                background: #ff111c;
                border-radius: 100px;
                font-size: 14px;
                color: #ffffff;
                line-height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;

                &:active {
                  opacity: 0.8;
                }

                &.plain {
                  border: 1px solid #ff111c;
                  background-color: transparent;
                  color: #ff111c;
                }

                &.disabled {
                  opacity: 0.4;
                  pointer-events: none;
                }
              }
            }

            + .item {
              margin-top: 12px;
            }
          }
        }
      }
    }
  }
</style>
